module.exports = __webpack_public_path__ + "img/sudan.6915277e.png";